// @ts-nocheck
import {useEffect, useState} from "react";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {useAuthStore} from "../../store/useAuth.store";
import LoginForm from "../Login";
import BaseModal from "../Modals";

const ProtectedRoute = ({children, requireAuth = true}) => {
  const authStatus = useAuthStore(state => state.authStatus);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authStatus === "login") {
      setShowModal(true);
    }

    return () => {
      setShowModal(false);
    };
  }, [authStatus]);

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/", {replace: true, state: {from: location}});
  };

  const setWindowWidth = () => {
    if (window.innerWidth <= 768) {
      return "90%";
    }

    return "950px";
  };

  // Show login modal when explicitly requested
  if (authStatus === "login") {
    return (
      <BaseModal
        state={showModal}
        width={setWindowWidth()}
        closeModal={() => handleCloseModal()}
      >
        <LoginForm />
      </BaseModal>
    );
  }

  if (authStatus === "checking") {
    return null;
  }

  if (requireAuth && authStatus === "unauthenticated") {
    return (
      <Navigate
        to="/"
        replace
        state={{from: location}}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
